import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { toast } from 'react-toastify';

import StarIcon from '@material-ui/icons/Star';
import SaveAlt from '@material-ui/icons/SaveAlt';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import LinkMaterial from '@material-ui/core/Link';

import Paper from '~/components/Paper';
import Button from '~/components/Button';
import Table from '~/components/Table/Table';
import GridItem from '~/components/GridItem';
import InputDate from '~/components/Input/InputDate';
import GridContainer from '~/components/GridContainer';
import LinearProgress from '~/components/LinearProgress';
import tableStyles from '~/components/Table/Table/styles';
import InputControl from '~/components/Input/InputControl';
import TablePagination from '~/components/Table/TablePagination';
import InputSearch from '~/components/Input/InputSearch';
import InputSelect from '~/components/Input/InputSelect';

import { showMedicalAppointments } from '~/config/routes';
import Request from '~/providers/Request';

import toInt from '~/utils/Number/toInt';
import isPresent from '~/utils/isPresent';
import csvGenerator from '~/utils/csvGenerator';
import xlsxGenerator from '~/utils/xlsxGenerator';
import isBlank from '~/utils/isBlank';
import CurrentUser from '~/contexts/CurrentUser';
import { appointmentRatingOptions } from '../../../config/constants';
import InputMultiCorporation from '../../../components/Input/InputMultiCorporation';

function AppointmentRating() {
  const { t } = useTranslation();
  const classesTable = tableStyles();
  const [loading, setLoading] = useState(false);
  const [userActives, setUserActives] = useState([]);
  const [totalUserActives, setTotalUserActives] = useState(0);
  const [dataInit, setDataInit] = useState(moment().startOf('month').format());
  const [dataEnd, setDataEnd] = useState(moment().endOf('month').format());
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [inputSearch, setInputSearch] = useState('');
  const { user } = useContext(CurrentUser);
  const [role_type, setRoleType] = useState('all');
  const [corporation, setCorporation] = useState([{
    corporation_id: null,
    id: null,
    name: 'Todas',
  }]);

  const trAttr = (attr) => t(`appointmentRating.attributes.${attr}`);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  async function generateFile(filters, type) {
    try {
      const registers = await Request.get(
        '/admin/report/appoiments_ratings',
        filters,
        {
          normalizeJSON: false,
        }
      );

      const rows = [];

      rows.push([
        'Período',
        `${moment(filters.start).format('DD/MM/YYYY HH:mm')} a ${moment(
          filters.end
        ).format('DD/MM/YYYY HH:mm')}`,
      ]);

      rows.push(['']);
      rows.push([
        'ID',
        'Nome',
        'Data Atendimento',
        'Hora Atendimento',
        'Empresa',
        'Médico Avaliado',
        'Atendente avaliado',
        'Avaliação',
        'Período',
        'Dia da Semana',
        'Observação',
      ]);
      registers.data.map((item) => {
        if (isBlank(item.deleted_at)) {
          if (item.partner_name === null) item.partner_name = 'Particular';
          rows.push([
            item.id.toString(),
            item.user_name,
            moment(item.rated_at).format('DD/MM/YYYY'),
            moment(item.rated_at).format('HH:mm'),
            item.partner_name,
            item.doctor_name,
            item.attendant_name,
            getRating(item.rating),
            getPeriod(item.rated_at),
            getWeekDay(item.rated_at),
            item.observation,
          ]);
        }

        return item;
      });

      rows.push(['']);
      rows.push(['Relatório gerado por', user.name]);
      rows.push([
        'Relatório gerado em',
        `${moment().format('L')} - ${moment().format('LT')}`,
      ]);

      if (type === 'csv') csvGenerator(`avaliação_de_consultas.csv`, [...rows]);
      else xlsxGenerator(`avaliação_de_consultas.xlsx`, [...rows]);

      toast.success(
        `Arquivo ${type.toLocaleUpperCase()} de avaliações gerado com sucesso!`
      );

      const totalPages = toInt(registers.meta.total) / registers.meta.perPage;
      if (registers.meta.page < totalPages) {
        filters.page += 1;
        generateFile(filters, type);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        `Não foi possível gerar o arquivo ${type.toLocaleUpperCase()} de avaliações`
      );
    }
  }
  const corpsId = corporation
  ? `[${corporation.map((corp) => corp.id).join(',')}]`
  : null;

  const corpsCorporationId = corporation
  ? `[${corporation.map((corp) => corp.corporation_id).join(',')}]`
  : null;

  function onExport(type) {
    const filters = {
      start: dataInit,
      end: dataEnd,
      qs: inputSearch,
      page: 1,
      per_page: 50000,
      role_type,
      partners: corpsId,
      corporations: corpsCorporationId,
    };
    toast.info(`Arquivo ${type.toLocaleUpperCase()} esta sendo gerado!`);
    generateFile(filters, type);
  }

  async function getUserRating() {
    setLoading(true);

    const filters = {
      start: dataInit,
      end: dataEnd,
      page: page + 1,
      qs: inputSearch,
      per_page: rowsPerPage,
      role_type,
      partners: corpsId,
      corporations: corpsCorporationId,

    };

    Request.get('/admin/report/appoiments_ratings', filters, {
      normalizeJSON: false,
    })
      .then((response) => {
        const { data, meta } = response;
        setLoading(false);
        setUserActives(data);
        setPage(toInt(meta.page) - 1);
        setTotalUserActives(toInt(meta.total));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  async function fetchParams() {
    const url = new URLSearchParams(window.location.search);

    const start = url.get('start');
    const end = url.get('end');

    if (isPresent(start)) {
      const startDate = moment(start);

      if (startDate.isValid()) {
        setDataInit(startDate.format());
      }
    }
    if (isPresent(end)) {
      const endDate = moment(end);

      if (endDate.isValid()) {
        setDataEnd(endDate.format());
      }
    }
  }

  useEffect(() => {
    if (dataInit && dataEnd) {
      getUserRating();
    }
  }, [page, inputSearch, rowsPerPage, dataInit, dataEnd, role_type, corporation]);

  useEffect(() => {
    fetchParams();
  }, []);

  function getRating(rating) {
    switch (rating) {
      case 1:
        return '1 - Ruim';
      case 2:
        return '2 - Regular';
      case 3:
        return '3 - Bom';
      case 4:
        return '4 - Muito bom';
      case 5:
        return '5 - Excelente';
      default:
        return 'Sem resposta';
    }
  }

  function getPeriod(period) {
    const hour = moment(period).format('HH:mm');
    if (hour >= '06:00' && hour <= '12:00') {
      return 'Manhã';
    }
    if (hour >= '12:00' && hour <= '18:00') {
      return 'Tarde';
    }
    if (hour >= '18:00' && hour <= '23:59') {
      return 'Noite';
    }
    return 'Manhã';
  }

  function getWeekDay(date) {
    let day = moment(date).format('dddd');
    day = day.charAt(0).toUpperCase() + day.slice(1);
    return day;
  }
    return (
    <>
      <Paper
        Icon={StarIcon}
        iconColor="blue"
        title={t('dashboard.attributes.appointment_rating')}
      >
        <GridContainer>
          <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
            <InputControl
              value={dataInit}
              name="date"
              label={t('appointmentRating.extras.date_init')}
              inputComponent={InputDate}
              InputProps={{
                type: 'date',
              }}
              onChange={(date) => {
                setDataInit(moment(date).startOf('day').format());
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
            <InputControl
              value={dataEnd}
              name="date"
              label={t('appointmentRating.extras.date_end')}
              inputComponent={InputDate}
              InputProps={{
                type: 'date',
              }}
              onChange={(date) =>
                setDataEnd(moment(date).endOf('day').format())
              }
            />
          </GridItem>
          <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
            <InputMultiCorporation corporation={corporation} setCorporation={setCorporation} />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={8} xl={4}>
            <InputSearch
              value={inputSearch}
              label={t('action.search')}
              placeholder={t('appointmentRating.extras.search')}
              onChange={setInputSearch}
            />
          </GridItem>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputControl
              name={'pack'}
              label={t('appointmentRating.extras.type')}
              value={appointmentRatingOptions[role_type]}
              inputComponent={InputSelect}
              onChange={({ pack }) => {
                setRoleType(pack);
              }}
              InputProps={{
                outValueType: 'string',
                options: Object.keys(appointmentRatingOptions).map((key) => ({
                  id: key,
                  name: appointmentRatingOptions[key],
                })),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem align="right">
            <Button
              color="second"
              onClick={() => {
                onExport('csv');
              }}
            >
              {t('action.export_csv')} <SaveAlt />
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              color="orange"
              onClick={() => {
                onExport('xlsx');
              }}
            >
              {t('action.export_xlsx')} <SaveAlt />
            </Button>
          </GridItem>
        </GridContainer>

        <LinearProgress loading={loading} />

        <Table
          emptyData={userActives.length === 0}
          loading={loading}
          columns={
            <>
              <TableCell className={classesTable.cell}>
                {trAttr('id')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('name')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('rated_at')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('hour')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('corporation')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('doctor_name')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('attendant_name')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('rating')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('period')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('week_day')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('observation')}
              </TableCell>
            </>
          }
        >
          {userActives.map((row) => {
            if (row.partner_name === null) row.partner_name = 'Particular';
            return (
              <TableRow
                key={`${row.id}-${row.partner_name}`}
                hover
                className={classesTable.row}
              >
                <TableCell>
                  <Chip
                    label={row.id}
                    component={LinkMaterial}
                    href={showMedicalAppointments.reverse({
                      id: row.id,
                    })}
                    style={{ cursor: 'pointer' }}
                    target="_blank"
                    color="primary"
                    variant="outlined"
                    onDelete={() => {}}
                    deleteIcon={<OpenInNewIcon />}
                  />
                </TableCell>
                <TableCell>{row.user_name}</TableCell>
                <TableCell>
                  {moment(row.rated_at).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell>{moment(row.rated_at).format('HH:mm')}</TableCell>
                <TableCell>{row.partner_name}</TableCell>
                <TableCell>{row.doctor_name}</TableCell>
                <TableCell>{row.attendant_name}</TableCell>
                <TableCell>{getRating(row.rating)}</TableCell>
                <TableCell>{getPeriod(row.rated_at)}</TableCell>
                <TableCell>{getWeekDay(row.rated_at)}</TableCell>
                <TableCell>{row.observation}</TableCell>
              </TableRow>
            );
          })}
        </Table>

        <LinearProgress loading={loading} />

        <Typography
          variant="subtitle2"
          color="primary"
          align="right"
          style={{ paddingRight: 16, marginTop: 10 }}
        >
          <strong>Total: </strong>
          {totalUserActives}
        </Typography>

        <TablePagination
          count={totalUserActives}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}

export default AppointmentRating;
